export interface UserMessageData {
    id?: number;
    date?: Date;
    subject?: string;
    body?: string;
    extra?: string;
    disclaimer?: string;
    importance?: number;
    icon?: string;
    buttons?: UserMessageButton[];
    dismissable?: boolean;
    loanId?: number;
    isEntityMessage?: boolean;
    entityId?: number;
    messageType?: UserMessageType;
}

export const USER_MESSAGE_RETURN_URL_STORAGE_KEY = 'userMessages.returnUrl';

/**
 * Cookie holding the set of popup fingerprints already shown in the current SSO
 * session. A cookie (scoped to the registrable domain) is used instead of
 * sessionStorage so the acknowledgement is shared across subdomains
 * (my.* <-> portal.*) after a cross-origin "Fund a Case" redirect (RYNO-14713).
 */
export const DISPLAYED_USER_MESSAGES_COOKIE = 'displayedUserMessages';

export enum UserMessageType {
    OnScreen = 'on-screen',
    PopUp = 'popup'
}

export interface UserMessageButton {
    label: string;
    link: string;
    appearance: ButtonAppearance;
}

export enum ButtonAppearance {
    normal = 'normal',
    emphasized = 'emphasized'
}

export enum UserMessageSubjects {
    ReferTwitter = 'Refer Twitter',
    UpdatedTermsAndConditions = 'Updated terms & conditions',
    EarnUpTo10000 = 'Earn up to $10,000',
    GeneralLiabilityInsurance = 'General Liability Insurance'
}
